import { useEffect, useRef } from 'react';

import { fg } from '@confluence/feature-gating';

type UseContentReloadOnFabricSupportChangeProps = {
	contentId: string;
	fabricEditorSupported: boolean | null;
	bodyRepresentation: string | null;
	reload: () => Promise<any>;
};
export const useContentReloadOnFabricSupportChange = ({
	contentId,
	fabricEditorSupported,
	bodyRepresentation,
	reload,
}: UseContentReloadOnFabricSupportChangeProps): void => {
	const currentContentId = useRef<string | null>(null);
	const currentFabricEditorSupportedRef = useRef<boolean | null>(null);
	const currentBodyRepresentationRef = useRef<string | null>(null);

	useEffect(() => {
		if (!fg('confluence_refetch_content_on_fabric_support_chng')) {
			return;
		}

		// If the content ID changes, just set the values.
		if (contentId !== currentContentId.current) {
			currentContentId.current = contentId;
			currentFabricEditorSupportedRef.current = fabricEditorSupported;
			currentBodyRepresentationRef.current = bodyRepresentation;
		}
		// If either values change to/from null, just assign them.
		else if (
			fabricEditorSupported === null ||
			currentFabricEditorSupportedRef.current === null ||
			bodyRepresentation === null ||
			currentBodyRepresentationRef.current === null
		) {
			currentFabricEditorSupportedRef.current = fabricEditorSupported;
			currentBodyRepresentationRef.current = bodyRepresentation;
		}
		// If either value differs from the ref, refetch the content.
		else if (
			fabricEditorSupported !== currentFabricEditorSupportedRef.current ||
			bodyRepresentation !== currentBodyRepresentationRef.current
		) {
			currentFabricEditorSupportedRef.current = fabricEditorSupported;
			currentBodyRepresentationRef.current = bodyRepresentation;
			void reload();
		}
	}, [contentId, fabricEditorSupported, bodyRepresentation, reload]);
};
